import { useEffect, useRef, useCallback } from "react";

type ExitIntentOptions = {
  onExitIntent: () => void;
  threshold?: number;
  enabled?: boolean;
};

export function useExitIntent({ onExitIntent, threshold = 50, enabled = true }: ExitIntentOptions) {
  const hasTriggeredRef = useRef(false);
  const onExitIntentRef = useRef(onExitIntent);

  useEffect(() => {
    onExitIntentRef.current = onExitIntent;
  }, [onExitIntent]);

  const reset = useCallback(() => {
    hasTriggeredRef.current = false;
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;

    const handleMouseOut = (event: MouseEvent) => {
      if (hasTriggeredRef.current) return;
      if (event.relatedTarget === null && event.clientY <= threshold) {
        hasTriggeredRef.current = true;
        onExitIntentRef.current();
      }
    };

    document.documentElement.addEventListener("mouseout", handleMouseOut);

    return () => {
      document.documentElement.removeEventListener("mouseout", handleMouseOut);
    };
  }, [enabled, threshold]);

  return { reset };
}
